// Lucide icon: arrow-right-from-line (https://lucide.dev/icons/arrow-right-from-line)
import { ArrowRightFromLine } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconMoveRight = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <ArrowRightFromLine />
    </IconComponentStyled>
  )
}
